// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_SIGNUP = "Registr\u00e1cia nov\u00e9ho \u010dlena";
